import { adapter } from '@seek/tealium-adapter';

export const trackView = (eventName: string | string[], data: any) => {
  const tracker = adapter();
  tracker.view(eventName, data);
};
